// extracted by mini-css-extract-plugin
export default {"coursesWrapper":"styles_coursesWrapper__g5gze","emptyValue":"styles_emptyValue__TfEKt"};